// Traducciones específicas para la página de compra directa - Español
export const buyDirectEs = {
  hero: {
    title: 'Compramos Tu Auto',
    description:
      'Vende tu vehículo de forma rápida, segura y al mejor precio. Evaluación justa y pago inmediato.',
  },
  form: {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    brand: 'Marca',
    brandPlaceholder: 'Selecciona una marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecciona un modelo',
    year: 'Año',
    mileage: 'Kilometraje',
    condition: 'Condición del Vehículo',
    askingPrice: 'Precio solicitado',
    message: 'Detalles adicionales',
    plate: 'Patente',
    platePlaceholder: 'Ej: ABCD12',
    plateInvalid: 'Revisa la patente: son letras y números, como ABCD12.',
    version: 'Versión (opcional)',
    versionPlaceholder: 'Ej: EXL 1.5 CVT',
    submit: 'Solicitar Tasación',
  },
  info: {
    advantagesTitle: 'Por Qué Vendernos Tu Auto',
    benefitsTitle: 'Nuestras ventajas',
    benefitsList: {
      item1: 'Tasación justa basada en el valor real de mercado',
      item2: 'Pago inmediato garantizado',
      item3: 'Nos encargamos de toda la documentación',
      item4: 'Sin costos ocultos ni comisiones',
      item5: 'Proceso rápido y seguro',
    },
    processTitle: 'Proceso de venta',
    processList: {
      step1: 'Envío de información básica del vehículo',
      step2: 'Evaluación técnica y tasación',
      step3: 'Oferta formal de compra',
      step4: 'Firma de documentos y traspaso',
      step5: 'Pago inmediato',
    },
    directContactTitle: 'Contacto Directo',
    emailLabel: 'Email',
    phoneLabel: 'Teléfono',
  },
  embed: {
    infoTitle: '¿Cómo funciona?',
    steps: [
      { title: 'Envía tus datos', desc: 'Completa el formulario con la información de tu vehículo.' },
      { title: 'Evaluamos', desc: 'Nuestro equipo revisa los datos y evalúa tu vehículo.' },
      { title: 'Te hacemos una oferta', desc: 'Recibirás una oferta justa y transparente.' },
      { title: 'Pago inmediato', desc: 'Si aceptas, realizamos el pago de forma inmediata.' },
    ],
    benefitsTitle: 'Beneficios',
    benefits: ['Oferta al instante', 'Pago inmediato', 'Sin comisiones ocultas', 'Trámites incluidos'],
  },
};

